import { render, staticRenderFns } from "./TheBills.vue?vue&type=template&id=0d0dcf5e&"
import script from "./TheBills.vue?vue&type=script&lang=js&"
export * from "./TheBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports